const telemarketingLawsAustralia = {
  slug: 'telemarketing-laws-australia',
  title: 'Telemarketing laws in Australia',
  description:
    'Do Not Call Register, ACMA rules, and your rights when marketers call — and how this differs from scam calls.',
  category: 'guides',
  guideType: 'guide',
  readMinutes: 4,
  partnerTip: 'none',
  relatedSlugs: ['managing-unwanted-calls', 'report-phone-scam-australia'],
  sections: [
    {
      type: 'paragraph',
      text: 'Legal telemarketing is regulated; criminal scams are not “telemarketing” but fraud. Knowing the rules helps you complain effectively.',
    },
    {
      type: 'heading',
      level: 2,
      text: 'Do Not Call Register',
    },
    {
      type: 'paragraph',
      text: 'Australian numbers can be listed on the Do Not Call Register at donotcall.gov.au. Telemarketers must not call listed numbers (with some exceptions, e.g. charities you support, surveys, government).',
    },
    {
      type: 'heading',
      level: 2,
      text: 'ACMA’s role',
    },
    {
      type: 'paragraph',
      text: 'The Australian Communications and Media Authority enforces telemarketing standards, including calling hours and caller ID requirements. Complaints about compliant telemarketers go to ACMA.',
    },
    {
      type: 'heading',
      level: 2,
      text: 'Scams vs marketing',
    },
    {
      type: 'list',
      items: [
        'Scam: impersonation, threats, gift cards, crypto, stealing codes — report to Scamwatch',
        'Unwanted legal marketing on a listed number — ACMA / Do Not Call complaints',
        'Harassment or threats — police',
      ],
    },
    {
      type: 'link',
      to: '/learn/regions/au',
      label: 'Australia reporting links',
    },
  ],
};

export default telemarketingLawsAustralia;
